import React from "react";
import { GasPump, Lightning, Hammer, Drop, Train, ShoppingCart, SunHorizon, Buildings, Car, FirstAid, GraduationCap, House } from "@phosphor-icons/react";
import { useI18n } from "../i18n/I18nContext";
import { useSiteContent } from "../i18n/SiteContent";

const ICONS = [GasPump, Lightning, Hammer, Drop, Train, ShoppingCart, SunHorizon, Buildings, Car, FirstAid, GraduationCap, House];

export default function Industries() {
  const { t } = useI18n();
  const { pg, pgList } = useSiteContent();
  const eyebrow = pg("industries.eyebrow", t.industries.eyebrow);
  const heading = pg("industries.heading", t.industries.heading);
  const sub = pg("industries.sub", t.industries.sub);
  const items = pgList("industries.items", t.industries.items);
  return (
    <section id="industries" data-testid="industries-section" className="py-10 md:py-20 bg-white reveal">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="max-w-4xl">
          <h2 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl lg:text-[54px] leading-[1.05] anim anim-up" style={{ color: "#0F2A6E", letterSpacing: "-0.025em" }}>
            {heading}
          </h2>
          <p className="mt-6 text-[#6B7A8D] text-lg md:text-xl font-light leading-relaxed max-w-2xl">
            {sub}
          </p>
        </div>

        <div className="mt-10 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 stagger anim">
          {items.map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={i}
                data-testid={`industry-card-${i}`}
                className="anim anim-scale card-lift group p-7 rounded-2xl border border-slate-200 bg-white hover:border-[#1B6FE0]/40"
              >
                <div
                  className="w-11 h-11 rounded-xl flex items-center justify-center mb-5"
                  style={{ background: "rgba(27,111,224,0.08)", color: "#1B6FE0" }}
                >
                  <Icon size={20} weight="duotone" />
                </div>
                <h3 className="font-heading font-semibold text-[18px] tracking-tight" style={{ color: "#0F2A6E", letterSpacing: "-0.01em" }}>
                  {it.title}
                </h3>
                {it.desc && <p className="mt-2 text-[13.5px] text-[#6B7A8D] leading-relaxed">{it.desc}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
